module.exports = "https://static.wagwalking.com/_next/static/images/drop-in-3-c0902fda21a15da828849c4cbcaa0bfa.svg";